import React from "react";
import { MaturityDate } from "@/contexts/DealContext";
import TextField, { FilledTextFieldProps, OutlinedTextFieldProps, StandardTextFieldProps, TextFieldVariants } from "@mui/material/TextField/TextField";
import { JSX } from "react/jsx-runtime";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DateTimePicker, DatePicker, LocalizationProvider } from '@mui/x-date-pickers';

type MaturityDateReviewProps = {
  maturityDate: MaturityDate;
  onChange: (updatedMaturityDate: MaturityDate) => void;
};

const MaturityDateReview = ({
  maturityDate,
  onChange,
}: MaturityDateReviewProps) => {
  console.log("MaturityDateReview render", maturityDate);
  return (<div>
    { maturityDate?.rule &&
      <TextField
        fullWidth
        style={{ marginBottom: "16px" }}
        label={"Management rule to compute maturity date"}
        variant="outlined"
        value={maturityDate?.rule || ""}
        onChange={(e) =>
          onChange({
            ...maturityDate,
            rule: e.target.value,
          })
        }
      />
    }
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        sx={{ width: '100%', marginBottom: '16px' }}
        format="MM/dd/yyyy"
        slotProps={{
          textField: {
          variant: "outlined",
          fullWidth: true,
          onClick: (e) => {
            e.currentTarget.querySelector('button')?.click();
          }
          },
        }}
        label="Maturity Date"
        value={maturityDate?.maturity_date ? new Date(maturityDate.maturity_date) : null}
        onChange={(newValue: Date | null) =>
          onChange({
          ...maturityDate,
          maturity_date: newValue ? newValue.toISOString() : undefined,
          })
        }
      />
    </LocalizationProvider>
  </div>
);

}

export default MaturityDateReview;